export enum AccordionMinimumHeight{
    EXTRASMALL = 250,
    SMALL = 400,
    MEDIUM = 600,
    LARGE = 800
}